var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scroll-pane", [
    _vm.activeRouteChange
      ? _c(
          "div",
          { attrs: { slot: "scroll" }, slot: "scroll" },
          [
            _c("state-inspector", {
              attrs: { state: { options: _vm.options } }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "no-route-data",
            attrs: { slot: "scroll" },
            slot: "scroll"
          },
          [_vm._v("\n    No route selected\n  ")]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }